<template>
  <div class="loading-process-page" v-if="isLoading">
    <div class="loading">
      <DotLottieVue :src="animationSrc" :speed="1" :autoplay="true" :loop="true" class="lottie" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
const animationSrc = new URL('@/assets/static/images/loading.json', import.meta.url).href; // .lottie 파일로 변경
const { getters } = useStore();
const isLoading = computed(() => getters['layout/getIsLoading']);
</script>

<style lang="scss">
.lottie {
  width: 50%;
}
</style>
